webpackJsonp([246384609461072],{

/***/ 397:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var detectPassiveEvents = {
	  update: function update() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          passive = true;
	        }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function noop() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	      detectPassiveEvents.hasSupport = passive;
	    }
	  }
	};
	
	detectPassiveEvents.update();
	exports.default = detectPassiveEvents;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(26);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(36);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(35);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(76);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(75);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author  Milos Janda
	 * @licence MIT
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tweenFunctions = __webpack_require__(589);
	
	var _tweenFunctions2 = _interopRequireDefault(_tweenFunctions);
	
	var _detectPassiveEvents = __webpack_require__(397);
	
	var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollUp = function (_React$Component) {
	    _inherits(ScrollUp, _React$Component);
	
	    function ScrollUp(props) {
	        _classCallCheck(this, ScrollUp);
	
	        // set default state
	        var _this = _possibleConstructorReturn(this, (ScrollUp.__proto__ || Object.getPrototypeOf(ScrollUp)).call(this, props));
	
	        _this.state = { show: false };
	
	        // default property `data`
	        _this.data = {
	            startValue: 0,
	            currentTime: 0, // store current time of animation
	            startTime: null,
	            rafId: null
	        };
	
	        // bind
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.scrollStep = _this.scrollStep.bind(_this);
	        _this.stopScrolling = _this.stopScrolling.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScrollUp, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextState.show !== this.state.show;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleScroll(); // initialize state
	
	            // Add all listeners which can start scroll
	            window.addEventListener('scroll', this.handleScroll);
	            window.addEventListener("wheel", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
	            window.addEventListener("touchstart", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // Remove all listeners which was registered
	            window.removeEventListener('scroll', this.handleScroll);
	            window.removeEventListener("wheel", this.stopScrolling, false);
	            window.removeEventListener("touchstart", this.stopScrolling, false);
	        }
	
	        /**
	         * Evaluate show/hide this component, depend on new position
	         */
	
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll() {
	            if (window.pageYOffset > this.props.showUnder) {
	                if (!this.state.show) {
	                    this.setState({ show: true });
	                }
	            } else {
	                if (this.state.show) {
	                    this.setState({ show: false });
	                }
	            }
	        }
	
	        /**
	         * Handle click on the button
	         */
	
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            this.stopScrolling();
	            this.data.startValue = window.pageYOffset;
	            this.data.currentTime = 0;
	            this.data.startTime = null;
	            this.data.rafId = window.requestAnimationFrame(this.scrollStep);
	        }
	
	        /**
	         * Calculate new position
	         * and scroll screen to new position or stop scrolling
	         * @param timestamp
	         */
	
	    }, {
	        key: 'scrollStep',
	        value: function scrollStep(timestamp) {
	            if (!this.data.startTime) {
	                this.data.startTime = timestamp;
	            }
	
	            this.data.currentTime = timestamp - this.data.startTime;
	
	            var position = _tweenFunctions2.default[this.props.easing](this.data.currentTime, this.data.startValue, this.props.topPosition, this.props.duration);
	
	            if (window.pageYOffset <= this.props.topPosition) {
	                this.stopScrolling();
	            } else {
	                window.scrollTo(window.pageYOffset, position);
	                this.data.rafId = window.requestAnimationFrame(this.scrollStep);
	            }
	        }
	
	        /**
	         * Stop Animation Frame
	         */
	
	    }, {
	        key: 'stopScrolling',
	        value: function stopScrolling() {
	            window.cancelAnimationFrame(this.data.rafId);
	        }
	
	        /**
	         * Render component
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var propStyle = this.props.style;
	            var element = _react2.default.createElement(
	                'div',
	                { style: propStyle, onClick: this.handleClick },
	                this.props.children
	            );
	
	            var style = (0, _objectAssign2.default)({}, ScrollUp.defaultProps.style);
	            style = (0, _objectAssign2.default)(style, propStyle);
	            style.opacity = this.state.show ? 1 : 0;
	            style.visibility = this.state.show ? 'visible' : 'hidden';
	            style.transitionProperty = 'opacity, visibility';
	
	            return _react2.default.cloneElement(element, { style: style });
	        }
	    }]);
	
	    return ScrollUp;
	}(_react2.default.Component);
	
	// Set default props
	
	
	exports.default = ScrollUp;
	ScrollUp.defaultProps = {
	    duration: 250,
	    easing: 'easeOutCubic',
	    style: {
	        position: 'fixed',
	        bottom: 50,
	        right: 30,
	        cursor: 'pointer',
	        transitionDuration: '0.2s',
	        transitionTimingFunction: 'linear',
	        transitionDelay: '0s'
	    },
	    topPosition: 0
	};
	
	// Set validation property types
	ScrollUp.propTypes = {
	    topPosition: _propTypes2.default.number,
	    showUnder: _propTypes2.default.number.isRequired, // show button under this position,
	    easing: _propTypes2.default.oneOf(['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack', 'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce']),
	    duration: _propTypes2.default.number, // seconds
	    style: _propTypes2.default.object
	};


/***/ }),

/***/ 589:
/***/ (function(module, exports) {

	'use strict';
	
	// t: current time, b: beginning value, _c: final value, d: total duration
	var tweenFunctions = {
	  linear: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * t / d + b;
	  },
	  easeInQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t + b;
	  },
	  easeOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (t /= d) * (t - 2) + b;
	  },
	  easeInOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    } else {
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    }
	  },
	  easeInCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t + b;
	  },
	  easeOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  },
	  easeInOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	  },
	  easeInQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t + b;
	  },
	  easeOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    } else {
	      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	    }
	  },
	  easeInQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t * t + b;
	  },
	  easeOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    }
	  },
	  easeInSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	  },
	  easeOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	  },
	  easeInOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    } else {
	      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	    }
	  },
	  easeInCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  },
	  easeOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  },
	  easeInOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    } else {
	      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	    }
	  },
	  easeInElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	  },
	  easeOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	  },
	  easeInOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d / 2) === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    if (t < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	    } else {
	      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
	    }
	  },
	  easeInBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  },
	  easeOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  },
	  easeInOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    }
	  },
	  easeInBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
	    return c - v + b;
	  },
	  easeOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	    }
	  },
	  easeInOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    if (t < d / 2) {
	      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
	      return v * 0.5 + b;
	    } else {
	      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
	      return v * 0.5 + c * 0.5 + b;
	    }
	  }
	};
	
	module.exports = tweenFunctions;


/***/ }),

/***/ 593:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      {
	        id: this.props.bg,
	        className: "bg-center w-100 flex  justify-center tc bb b--white-60" },
	      _react2.default.createElement(
	        "div",
	        { className: "mw8 " },
	        this.props.children
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyImage = __webpack_require__(65);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Masonry = function (_Component) {
	  _inherits(Masonry, _Component);
	
	  function Masonry() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Masonry);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.click = function (path) {
	      _this.props.openModal(path);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Masonry.prototype.render = function render(props) {
	    var _this2 = this;
	
	    var gifs = this.props.content.filter(function (e, i) {
	      return e.extension === "gif";
	    }).map(function (e, i) {
	      return _react2.default.createElement('img', {
	        key: i + "g",
	        onClick: function onClick() {
	          return _this2.click(e.relativePath);
	        },
	        className: 'mv3 db shadow-1 w-100 pointer dim ',
	        src: e.relativePath
	      });
	    });
	
	    var optimized = this.props.content.filter(function (e, i) {
	      return e.extension !== "gif";
	    }).map(function (e, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i + "Do", onClick: function onClick() {
	            return _this2.click(e.relativePath);
	          } },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          key: i + "o",
	          className: 'mv3 db shadow-1 w-100 pointer dim ',
	          src: e.relativePath,
	          sizes: e.childImageSharp.sizes
	        })
	      );
	    });
	
	    var allContent = [].concat(gifs, optimized);
	
	    var columns = new Array(this.props.cols);
	
	    for (var i = 0; i < columns.length; i++) {
	      columns[i] = [];
	    }
	
	    for (var _i = 0; _i < allContent.length; _i += columns.length) {
	      for (var j = 0; j < columns.length; j++) {
	        columns[j].push(allContent[_i + j]);
	      }
	    }
	
	    var organizedMasonryLarge = columns.map(function (col, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i + "L", className: 'ph2 w-' + Math.floor(100 / columns.length) + (i % 2 ? ' mt4' : '') },
	        col
	      );
	    });
	    var organizedMasonryMed = columns.map(function (col, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i + "M", className: 'ph2 w-100' },
	        col
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'relative w-100 mv3',
	        style: { color: "#EBFFFC" }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'dn flex-l relative self-center flex-row justify-between w-100' },
	        organizedMasonryLarge
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex flex-column  dn-l db' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex flex-column justify-center dn-l db' },
	          organizedMasonryMed
	        )
	      )
	    );
	  };
	
	  return Masonry;
	}(_react.Component);
	
	exports.default = Masonry;
	module.exports = exports['default'];

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.portQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Nav = __webpack_require__(34);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Header = __webpack_require__(54);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Masonry = __webpack_require__(271);
	
	var _Masonry2 = _interopRequireDefault(_Masonry);
	
	var _reactModal = __webpack_require__(96);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactScrollUp = __webpack_require__(564);
	
	var _reactScrollUp2 = _interopRequireDefault(_reactScrollUp);
	
	var _briefcase = __webpack_require__(593);
	
	var _briefcase2 = _interopRequireDefault(_briefcase);
	
	var _leafbreak_white = __webpack_require__(169);
	
	var _leafbreak_white2 = _interopRequireDefault(_leafbreak_white);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var modalStyles = {
	  content: {
	    position: "relative",
	    display: "flex",
	    height: "100%",
	    left: "0",
	    right: "0",
	    top: "0",
	    bottom: "0",
	    margin: "auto, 0",
	    border: "0px",
	    background: "none",
	    overflowY: "hidden"
	  },
	  overlay: {
	    background: "rgba(22, 28, 33, 0.9)",
	    position: "fixed",
	    width: "100%",
	    top: "0",
	    bottom: "0",
	    left: "50%",
	    transform: "translateX( -50%)"
	  }
	};
	
	var PortfolioPage = function (_React$Component) {
	  _inherits(PortfolioPage, _React$Component);
	
	  function PortfolioPage() {
	    _classCallCheck(this, PortfolioPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      modalPath: "",
	      showModal: false
	    };
	
	    _this.handleOpenModal = _this.handleOpenModal.bind(_this);
	    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
	    _this.scrollToContent = _this.scrollToContent.bind(_this);
	    return _this;
	  }
	
	  PortfolioPage.prototype.handleOpenModal = function handleOpenModal(path) {
	
	    this.setState({ modalPath: path, showModal: true });
	  };
	
	  PortfolioPage.prototype.handleCloseModal = function handleCloseModal() {
	    this.setState({ showModal: false });
	  };
	
	  PortfolioPage.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      _reactModal2.default.setAppElement('body');
	    }
	  };
	
	  PortfolioPage.prototype.scrollToContent = function scrollToContent(tag) {
	    console.log("tag");
	    var top = document.querySelector(tag).getBoundingClientRect().top;
	    if (typeof window !== undefined) {
	      setTimeout(window.scroll({ top: top, behavior: 'smooth' }), 100);
	    }
	  };
	
	  PortfolioPage.prototype.trimData = function trimData(portfolioSection) {
	    var trimmedData = this.props.data.allFile.edges.reduce(function (acc, curr) {
	      return acc.concat(curr.node);
	    }, []).filter(function (e) {
	      return e.relativeDirectory === portfolioSection;
	    });
	
	    return trimmedData;
	  };
	
	  PortfolioPage.prototype.render = function render() {
	    var document = typeof document === 'undefined' ? '' : document;
	    var edges = this.props.data.allFile.edges;
	
	    console.log();
	    var flyers = edges.filter(function (e) {
	      return e.node.relativeDirectory == "flyers";
	    });
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_Nav2.default, { page: "portfolio" }),
	      _react2.default.createElement(
	        "div",
	        { id: "back", style: { backgroundColor: "#19382B" }, className: "relative w-100 " },
	        _react2.default.createElement(
	          "div",
	          { className: " relative flex flex-column " },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { color: "#FDFDFD" },
	              className: "w-100 mw8 br3 mt2 pa3 flex flex-column justify-center self-center tc"
	            },
	            _react2.default.createElement("img", { className: "mw6 self-center mv0", src: _leafbreak_white2.default }),
	            _react2.default.createElement(
	              "h1",
	              { className: "mt3 f1-ns f2 self-center" },
	              "A collection of my best designs. "
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: " mw6 lh-copy self-center" },
	              "For me, creating a beautiful project is not optional. Scroll down to see the design skills I've developed during my career. Click to enlarge."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "w-100 mw8 self-center tc pt0 " },
	            _react2.default.createElement(
	              "div",
	              { className: "dn w-100  flex-ns  flex-row-ns flex-column justify-start ph2 ph0-ns mw7-l center mb5 mb0-ns" },
	              _react2.default.createElement(
	                "span",
	                { className: "white b f6 w3 mb2 mb0-ns flex flex-column justify-center" },
	                "Skip to:"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: " flex flex-row-ns flex-wrap justify-around items-center w-100" },
	                _react2.default.createElement(
	                  SubNavLink,
	                  { pass: "#we" },
	                  "WEB DESIGN"
	                ),
	                _react2.default.createElement(
	                  SubNavLink,
	                  { pass: "#po" },
	                  "POSTERS"
	                ),
	                _react2.default.createElement(
	                  SubNavLink,
	                  { pass: "#pr" },
	                  "PRINT MEDIA"
	                ),
	                _react2.default.createElement(
	                  SubNavLink,
	                  { pass: "#lo" },
	                  "LOGOS & BRANDS"
	                ),
	                _react2.default.createElement(
	                  SubNavLink,
	                  { pass: "#ph" },
	                  "PHOTOS & RASTER"
	                ),
	                _react2.default.createElement(
	                  SubNavLink,
	                  { pass: "#ot" },
	                  "OTHER"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              HH,
	              null,
	              "WEB DESIGN"
	            ),
	            _react2.default.createElement(_Masonry2.default, {
	              openModal: this.handleOpenModal,
	              content: this.trimData("websites").reverse(),
	              cols: 3
	            }),
	            _react2.default.createElement(
	              HH,
	              null,
	              "POSTERS"
	            ),
	            _react2.default.createElement(_Masonry2.default, {
	              openModal: this.handleOpenModal,
	              content: this.trimData("flyers"),
	              cols: 4
	            }),
	            _react2.default.createElement(
	              HH,
	              null,
	              "PRINT MEDIA"
	            ),
	            _react2.default.createElement(_Masonry2.default, {
	              openModal: this.handleOpenModal,
	              content: this.trimData("collateral").reverse(),
	              cols: 4
	            }),
	            _react2.default.createElement(
	              HH,
	              null,
	              "LOGOS & BRANDS"
	            ),
	            _react2.default.createElement(_Masonry2.default, {
	              openModal: this.handleOpenModal,
	              content: this.trimData("identity"),
	              cols: 4
	            }),
	            _react2.default.createElement(
	              HH,
	              null,
	              "PHOTOS & RASTER"
	            ),
	            _react2.default.createElement(_Masonry2.default, {
	              openModal: this.handleOpenModal,
	              content: this.trimData("photos"),
	              cols: 3
	            }),
	            _react2.default.createElement(
	              HH,
	              null,
	              "OTHER"
	            ),
	            _react2.default.createElement(_Masonry2.default, {
	              openModal: this.handleOpenModal,
	              content: this.trimData("other"),
	              cols: 4
	            }),
	            _react2.default.createElement(
	              "div",
	              {
	                style: { margin: "30rem 0rem 30rem 0rem" },
	                className: "w-100 white flex"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { backgroundColor: "#9d1c1f" },
	                  className: "center ba b--white relative br2"
	                },
	                _react2.default.createElement(
	                  "h5",
	                  {
	                    style: { top: "-.6rem", left: ".6rem", backgroundColor: "#9d1c1f" },
	                    className: " f7 tracked absolute top-0 ph2 pt1 white br2"
	                  },
	                  "HUNTER SAYS:"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "ma3 tracked tc b lh-copy" },
	                  " \"Thanks for checking out my design work. ",
	                  _react2.default.createElement("br", null),
	                  " ",
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/projects/", className: "white" },
	                    " Click here"
	                  ),
	                  " to see my programming projects.\""
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", justifyContent: "center" } },
	          _react2.default.createElement(_Footer2.default, null)
	        ),
	        _react2.default.createElement(
	          _reactScrollUp2.default,
	          { showUnder: 960 },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { backgroundColor: "#9d1c1f" },
	              className: "flex flex-row justify-center items-center white w4 pv3 br3 shadow-3 b hover-bg-red ba"
	            },
	            _react2.default.createElement(_reactFontawesome2.default, { name: "arrow-up", className: "mr2" }),
	            " TO TOP"
	          )
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            isOpen: this.state.showModal,
	            contentLabel: "Portfolio Modal",
	            onRequestClose: this.handleCloseModal,
	            shouldCloseOnOverlayClick: true,
	            style: modalStyles
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "h-100 w-100 flex flex-column justify-center items-center", onClick: this.handleCloseModal },
	            _react2.default.createElement("img", {
	              className: " mv0 shadow-3 br3 self-center", src: this.state.modalPath,
	              onClick: this.handleCloseModal
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return PortfolioPage;
	}(_react2.default.Component);
	
	var HH = function HH(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { className: "tl-ns tc mt5-l mt3 mb0 bb bw1-ns b--white-90 mh3 mh0-ns" },
	    _react2.default.createElement(
	      "h1",
	      {
	        className: " f2-ns f3 mt0 mb1 white-90",
	        id: children.substring(0, 2).toLowerCase(),
	        style: { letterSpacing: ".80rem" }
	      },
	      children
	    )
	  );
	};
	
	var SubNavLink = function SubNavLink(props) {
	  return _react2.default.createElement(
	    "a",
	    {
	      href: props.pass,
	      className: "pa1 pa2-l white hover-bg-white hover-black f7 br3 no-underline mv1 nowrap pointer ba b--white shadow-1" },
	    props.children
	  );
	};
	
	function scrollToContent(tag) {
	  var top = document.querySelector(tag).getBoundingClientRect().top;
	  if (typeof window !== undefined) {
	    window.scrollTo({ top: top, behavior: 'smooth' });
	  }
	}
	
	var portQuery = exports.portQuery = "** extracted graphql fragment **";
	
	exports.default = PortfolioPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-46ed92ce53282dbdfe5e.js